/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdAlertDetailsModel {
    getFixupPrototypeFunction() { return ThresholdAlertDetailsModel.fixupPrototype; }

    static newInstance(model: Partial<ThresholdAlertDetailsModel>): ThresholdAlertDetailsModel {
        let obj = Object.assign(new ThresholdAlertDetailsModel(), model);
        ThresholdAlertDetailsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdAlertDetailsModel>): ThresholdAlertDetailsModel {
        if (!model) return null;
        return ThresholdAlertDetailsModel.newInstance(<ThresholdAlertDetailsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdAlertDetailsModel) {
        if (!obj) return;

        models.ThresholdAlertDetailsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdAlertDetailsModel): boolean {
        Object.setPrototypeOf(obj, ThresholdAlertDetailsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * threshold name
     */
    threshold_name: string;

    /**
     * threshold uri
     */
    threshold_uri: string;

}
